import React from 'react';
import { Helmet } from "react-helmet";
import { ContactForm } from "../sections/Contact/Contact";

const Contact = () => {
    return (
        <>
            <Helmet>
                <title>Lembawe9 - Contact</title>
                <meta 
                    name="description" 
                    content="Official website of Lembawe9, the influential Moroccan street rap artist. Listen, shop, and connect." 
                />
            </Helmet>
            <main>
                <ContactForm/>
            </main>
        </>
    )
}

export default Contact
